module.exports = __webpack_public_path__ + "img/bounty_squad_big.1fee8767.png";